import { rem, ThemeIcon } from "@mantine/core";
import { IconArrowDown, IconArrowUp, IconCircle } from "@tabler/icons-react";

export const iconRadius = "xs";
export const iconHeight = 12;
export const iconStyle = { width: rem(iconHeight), height: rem(iconHeight) };

export const positiveIcon = (
  <ThemeIcon color="green" size={iconHeight} radius={iconRadius}>
    <IconArrowUp style={iconStyle} />
  </ThemeIcon>
);

export const negativeIcon = (
  <ThemeIcon color="red" size={iconHeight} radius={iconRadius}>
    <IconArrowDown style={iconStyle} />
  </ThemeIcon>
);

export const neutralIcon = (
  <ThemeIcon color="grey" size={iconHeight} radius={iconRadius}>
    <IconCircle style={iconStyle} />
  </ThemeIcon>
);
